import { useCallback } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import TransactionErrorHandler from 'src/utils/TransactionErrorHandler/TransactionErrorHandler';

export const useTxErrorHandler = () => {
	const walletAdapter = useDriftStore((s) => s.wallet?.current?.adapter);

	const handleTxError = useCallback(
		(error: any, toastId: string, errorTitle?: string) => {
			if (!walletAdapter) return;

			TransactionErrorHandler.handleError({
				error,
				toastId,
				wallet: walletAdapter,
				errorTitle,
			});
		},
		[walletAdapter]
	);

	return handleTxError;
};
